import React, { useEffect, useState } from "react";
import * as S from "./ContentEpisodes.style";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput";
import * as P from "../../../../../utils/pipes";
import { useTranslation } from "react-i18next";


function ContentEpisodes ({
  content
}) {  

console.log("khe", content);
  const { i18n: { language } } = useTranslation("global");

  return (
    <S.ContentEpisodes>
      {
        content.mediaCards.map((item, index) => (
          <div className="episode-item" key={index}>
            <div className="number">{index+1}</div>
            <div className="episode-data">
              <a className="episode-title"
                href={item.linkUrl}
                target="_blank"
              >
                {
                  P.dataTranslation(item.title, language)
                }
              </a>
              <div className="episode-description">
                {
                  P.dataTranslation(item.description, language)
                }
              </div>
            </div>
          </div>
        ))
      }
    </S.ContentEpisodes>
  )

}

export default ContentEpisodes;
